module.exports = __webpack_public_path__ + "static/media/1690643640twitter-x-icon-png.b3268505.png";